import vue from 'vue'
import Lockr from "lockr";
import dialog from './dialog'
import FormCom from "../FormCom";

// 组件构造器，构造出一个 vue组件实例
const DialogConstructor = vue.extend(dialog)

function DialogForm({
    title,
    data,
    success
}) {
    const DialogDom = new DialogConstructor({
        el: document.createElement('div'),
        components: {
            FormCom
        },
        data() {
            let {model, rules, field} = getFormData(data.field, data.source, data.setting, data.linkage)
            return {
                visible: true,
                title: title,
                opmode: data.opmode,
                type: data.type,
                request: data.request,
                field: field,
                labelWidth: data.labelWidth,
                success: success,
                model: model,
                rules: rules,
                linkage: data.linkage,
                data: data
            }
        },
        methods: {
            // 关闭
            close () {
                this.visible = false;
                DialogDom.$el.remove()
            },
            // 重置表单
            CancelForm(formName) {
                this.close()
                this.$refs[formName].resetFields();
            },
            // 表单验证
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.requestForm();
                    }
                });
            },
            // 表单提交
            requestForm() {
                let token = ''
                if (this.type == 'parent') {
                    token = Lockr.get("parentToken");
                } else if (this.type == 'user') {
                    token = Lockr.get("token");
                } else {
                    token = Lockr.get("teacherToken");
                }
                let params = {
                    ...this.model,
                    token
                }
                if (this.opmode) {
                    params.opmode = this.opmode;
                }
                this.request(params).then(result=>{
                    if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                        this.success(result)
                        this.close()
                    } else {
                        this.$message({
                            message: result.msg,
                            type: "warning"
                        });
                    }
                })
            }
        }
    })
    // 添加节点
    document.body.appendChild(DialogDom.$el)
}

// 注册表单数据
function getFormData(FormField = [], FormData = {}, settingData={}, linkageData={}) {
    let rules = {}, model = {}, field = []
    if (FormField.length) { 
        field = FormField.map((item, index, arr) => {
            let  arrItem= []
            if (item.required) {
                let obj = {}
                obj.required = true
                if (item.form_type == 'text' || item.form_type == 'number' || item.form_type == 'textarea' || item.form_type == 'mobile' || item.form_type == 'email' || item.form_type == 'password') {
                    obj.message = "请输入" + item.label
                    obj.trigger = "blur"
                } else if (item.form_type == 'select' || item.form_type == 'radio' || item.form_type == 'checkbox' || item.form_type == 'select_course') {
                    obj.message = "请选择" + item.label
                    obj.trigger = "change"
                }
                arrItem.push(obj)
            }
            rules[item.field] = arrItem
            if (item.form_type == 'select') {
                model[item.field] = parseFloat(FormData[item.field]) || item.default_value;
                if (settingData[item.field]) {
                    item['setting'] = settingData[item.field]
                }
            } else {
                model[item.field] = FormData[item.field] || item.default_value;
            }
            if (linkageData[item.field]) {
                item.linkage = linkageData[item.field]
            }
            return item
        })
    }
    return {
        rules,
        model,
        field
    }
}

export default DialogForm